var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXpzLogo = function SvgXpzLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 124"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    stroke: "url(#xpzLogo_svg__a)",
    strokeWidth: 2.571,
    d: "M55.357 3.222a9.29 9.29 0 0 1 9.286 0l43.961 25.381a9.29 9.29 0 0 1 4.643 8.042v50.762a9.29 9.29 0 0 1-4.643 8.042L64.643 120.83a9.28 9.28 0 0 1-9.286 0L11.396 95.449a9.29 9.29 0 0 1-4.643-8.042V36.645a9.29 9.29 0 0 1 4.643-8.042z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.112 52.902c0 2.453-.92 4.793-2.588 6.587a9.7 9.7 0 0 1-3.556 2.425s-.073.067-1.338.38c-1.266.312-1.48.317-1.48.317H60.513v14.567H53.3V55.355h7.213v.014H71.43a2.47 2.47 0 0 0 2.468-2.467 2.47 2.47 0 0 0-2.628-2.462l-.018.001-.05.008h-1.17v-.015H53.3V43.22h18.59s.771.095 1.475.231c.705.137 1.21.29 1.21.29a9.68 9.68 0 0 1 6.537 9.16m-44.138 6.765L48.12 44.534H41.14l-.193.26-7.462 10.136-7.657-10.396h-6.974L29.992 59.66l-.009.014 3.51 4.756.002-.002.524.699 7.907 10.737H48.9zm-10.802 5.194-8.101 11.004h6.975l4.62-6.272z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "m33.496 64.43-.002.001-3.51-4.756.009-.014-11.137-15.127h6.974l7.656 10.396 7.463-10.136.193-.26h6.977L36.974 59.667l11.928 16.198h-6.976L34.02 65.128zm5.109-4.763 12.11-16.447H40.48l-6.993 9.496-6.407-8.7-.585-.796H16.257l12.115 16.455-.012.015 4.592 6.22 8.31 11.268H51.5zM18.07 75.865l8.102-11.004 3.493 4.731-4.619 6.273zm8.102-13.216-10.7 14.53h10.24l5.584-7.587z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.633 75.356v-2.75H65.41v2.832zm2.203 1.848h-2.223v-.356l-1.583.244q-1.035.152-1.574.152-1.269 0-1.269-1.248V72.3q0-1.27 1.31-1.27h3.136v-2.354H65.41v1.462h-2.1V68.22q0-1.27 1.309-1.27h3.928q1.29 0 1.29 1.27zm8.609-10.253-2.57 10.12-.984 3.879h-2.375l1.066-3.827-2.599-10.172h2.386l1.35 6.74 1.35-6.74zm4.631-23.9h21.452v7.312L92.68 69.865h11.848v7.313H83.076v-7.313l11.847-19.502H83.076z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xpzLogo_svg__a",
    x1: 60,
    x2: 60,
    y1: 2.026,
    y2: 122.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3EEFA",
    stopOpacity: 0.1
  })))));
};
export default SvgXpzLogo;